<!-- 作业反馈首页 -->
<template>
	<div>
		<keep-alive>
			<router-view></router-view>
		</keep-alive>
	</div>
</template>
<script>
	export default {
		name: "Index",
		data() {
			return {};
		},
		created() {},
		methods: {},
	};
</script>
